<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<ion-content
  *ngIf="!showRetry && !loading"
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <app-ion-common-label
    [id]="idLabelGender"
    labelStyle="display-rg"
    labelDescription="Qual foi o sexo atribuído no seu nascimento?"
    label="Essa classificação é uma exigência dos órgãos reguladores para investimentos em 
  produtos de previdência. Dados protegidos por sigilo bancário."
  >
  </app-ion-common-label>

  <div class="conent-center">
    <app-ion-common-radio
      [id]="idRadioGender"
      [ariaLabel]="textAria"
      [itens]="genderType"
      [selectedValue]="selectedItem"
      [disabled]="!this.edit"
      (valueNameCode)="selectedItemCode = $event"
      (changeRadio)="changeItem((selectedItem = $event))"
      (valueNameRadio)="selectedName = $event"
    ></app-ion-common-radio>
  </div>

  <app-ion-common-button
    [id]="idButtonGender"
    class="hidden"
    [ngClass]="{ hidden: !buttonEnable || !selectedItem }"
    [attr.aria-hidden]="!buttonEnable || !selectedItem"
    label="Continuar"
    (clickButton)="clickNext()"
  ></app-ion-common-button>
</ion-content>

<ion-content *ngIf="showRetry">
  <app-ion-common-retry
    [headerId]="headerId"
    (sendEventRetry)="getGenderType()"
  >
  </app-ion-common-retry>
</ion-content>
